"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[6645],{

/***/ 56645:
/***/ ((module) => {

module.exports = JSON.parse('{"anErrorOccured":"Ett fel uppstod","failedToFetchClientInformation":"Något gick fel när information om klienten skulle hämtas för att komma vidare till onboardingen. Kontrollera uppgifterna på klienten och försök igen."}');

/***/ })

}]);